export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        $currentUser() {
          return this.$store.getters['user/currentUser'];
        },
        $isCorpOrManager() {
          return this.$isCorp || this.$isManager;
        },
        $isAgent() {
          return this.$currentUser.activeRole === 'agent';
        },
        $isCorp() {
          return this.$currentUser.activeRole === 'corp';
        },
        $isManager() {
          return this.$currentUser.activeRole === 'manager';
        },
        $isContractor() {
          return this.$currentUser.activeRole === 'contractor';
        },
        $isOwner() {
          return this.$store.getters['user/currentUserHasRole']('owner');
        },
        $isAdmin() {
          return this.$store.getters['user/currentUserHasRole']('admin');
        }
      }
    });
  }
};
